import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { formatDateDDMMYYYY } from '@/lib/utils';

interface LastAction {
  type: string;
  description: string;
  date: Date;
  performedBy: string;
}

interface LastActionCellProps {
  readonly lastAction?: LastAction | null;
}

export function LastActionCell({ lastAction }: LastActionCellProps) {
  if (!lastAction) {
    return <span className="text-muted-foreground">—</span>;
  }

  const title = lastAction.type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-1 cursor-help">
            <span className="truncate max-w-[150px]">{lastAction.description || title}</span>
            <HelpCircle className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="w-72 p-3">
          <div className="space-y-1">
            <p className="font-semibold text-sm">{title}</p>
            <p className="text-xs whitespace-normal line-clamp-3">{lastAction.description}</p>
            <div className="flex items-center justify-between text-xs text-muted-foreground pt-1 border-t">
              <span>{lastAction.performedBy}</span>
              <span>{formatDateDDMMYYYY(lastAction.date.toISOString())}</span>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
